import React from "react";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import BenefitsSection from "../components/BenefitsSection";
import HowItWorksSection from "../components/HowItWorksSection";
import ContactSection from "../components/ContactSection";
import "../App.css";

function App() {
  return (
    <div>
      <HeroSection />
      <AboutSection />
      <BenefitsSection />
      <HowItWorksSection />
      <ContactSection />
    </div>
  );
}

// hola

export default App;
